<template>
  <div class="food-manage">

    <div class="tuolele-main-box">
      <el-tabs v-model="tabActiveName" type="border-card">
        <el-tab-pane label="食谱" name="school">
          <el-form :inline="true" :model="listQuery" class="fn-clear">
            <el-form-item label="" class="fn-left">
              <Select key="4" :selected.sync="listQuery.status" :data="selectList" clearable placeholder="请选择状态" />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="listQuery.begin_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="开始日期"
              />
              <i class="split-time">至</i>
              <el-date-picker
                v-model="listQuery.end_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="" class="fn-right">
              <el-button type="warning" @click="fnReleaseMenu()">发布</el-button>
            </el-form-item>
            <el-form-item label="" class="fn-right">
              <el-button type="success" @click="fnToAddMenuDetail()">添加</el-button>
            </el-form-item>
            <el-form-item label="" class="fn-right">
              <el-button type="primary" @click="fnGetRecipeList">查询</el-button>
            </el-form-item>

          </el-form>
          <el-table :key="'student' + tableKey" :data="list" border stripe>
            <el-table-column label="日期" prop="show_time" align="center" />
            <el-table-column label="是否发布" prop="status_name" align="center" />
            <el-table-column label="价格" prop="sub_name" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.appoint_price/100 }}元</span>
              </template>
            </el-table-column>
            <el-table-column label="餐次" prop="appoint_period_name" align="center" />
            <el-table-column label="名称" prop="recipe_title" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button v-show="chechTimeExpire(scope.row.show_time)" type="text" @click="fnUpdateMenu(scope.row.recipe_id)">编辑</el-button>
                <el-button v-show="scope.row.status == 1" type="text" @click="fnUpdateMenu(scope.row.recipe_id)">查看</el-button>
                <el-button v-show="scope.row.status == 0" type="text" style="color:red!important" @click="fnDeleteMenu(scope.row.recipe_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer pagination-footer">
            <div class="block">
              <el-pagination
                layout="prev, pager, next, slot, jumper"
                :current-page.sync="listQuery.p"
                prev-text="上一页"
                next-text="下一页"
                :total="total"
                :page-size="listQuery.limit"
                @current-change="fnGetRecipeList"
              >
                <div class="chax">
                  {{ listQuery.p }}/{{
                    total > 0 ? Math.ceil(total / listQuery.limit) : 1
                  }}
                </div>
              </el-pagination>
              <div class="insert">
                <el-button type="primary">确定</el-button>
                <span class="pagination-count">
                  符合查询结果:
                  <i>{{ total }}条</i>
                </span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="公司食谱" name="company">
          <el-form :inline="true" :model="companylListQuery" class="fn-clear">
            <el-form-item label="" class="fn-left">
              <Select key="4" :selected.sync="companylListQuery.status" :data="selectList" clearable placeholder="请选择状态" />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="companylListQuery.begin_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="开始日期"
              />
              <i class="split-time">至</i>
              <el-date-picker
                v-model="companylListQuery.end_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="" class="fn-right">
              <el-button type="warning" @click="fnReleaseMenu()">发布</el-button>
            </el-form-item>
            <el-form-item label="" class="fn-right">
              <el-button type="success" @click="fnToAddMenuDetail()">添加</el-button>
            </el-form-item>

            <el-form-item label="" class="fn-right">
              <el-button type="primary" @click="fnGetCompanyRecipeList">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table :key="'student' +companyTableKey" :data="companyLists" border stripe>
            <el-table-column label="日期" prop="show_time" align="center" />
            <el-table-column label="名称" prop="recipe_title" align="center" />
            <el-table-column label="餐次" prop="appoint_period_name" align="center" />
            <el-table-column label="是否发布" prop="status_name" align="center" />
            <el-table-column label="价格" prop="sub_name" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.appoint_price/100 }}元</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button v-show="scope.row.status == 0" type="text" @click="fnUpdateMenu(scope.row.recipe_id)">编辑</el-button>
                <el-button v-show="scope.row.status == 1" type="text" @click="fnUpdateMenu(scope.row.recipe_id)">查看</el-button>
                <el-button v-show="scope.row.status == 0" type="text" style="color:red!important" @click="fnDeleteMenu(scope.row.recipe_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer pagination-footer">
            <div class="block">
              <el-pagination
                layout="prev, pager, next, slot, jumper"
                :current-page.sync="companylListQuery.p"
                prev-text="上一页"
                next-text="下一页"
                :total="companyTotal"
                :page-size="companylListQuery.limit"
                @current-change="fnGetCompanyRecipeList"
              >
                <div class="chax">
                  {{ companylListQuery.p }}/{{
                    total > 0 ? Math.ceil(total / companylListQuery.limit) : 1
                  }}
                </div>
              </el-pagination>
              <div class="insert">
                <el-button type="primary">确定</el-button>
                <span class="pagination-count">
                  符合查询结果:
                  <i>{{ total }}条</i>
                </span>
              </div>
            </div>
          </div>
        </el-tab-pane> -->

      </el-tabs>

    </div>

  </div>

</template>
<script>
import Select from '@/components/Select'
var moment = require('moment')

export default {
  name: 'FoodMenuManage',
  components: {
    Select
  },
  data() {
    return {
      type: 'singing',
      list: [],
      companyLists: [],
      selectList: [],
      total: 0,
      companyTotal: 0,
      tableKey: 0,
      companyTableKey: 0,
      bShowReleaseButton: false,
      tabActiveName: 'school',
      listQuery: {
        p: 1,
        status: '',
        begin_time: '',
        end_time: '',
        limit: 20,
        scope_application: 2
      },
      companylListQuery: {
        p: 1,
        status: '',
        begin_time: '',
        end_time: '',
        limit: 20,
        scope_application: 1
      }
    }
  },
  created() {
    // const date = new Date()
    // const year = date.getFullYear()
    // const month = date.getMonth() + 1
    // const day = date.getDate()
    // this.search.begin_time = year + '-' + date.getMonth() + '-' + day
    // this.search.end_time = year + '-' + month + '-' + day
    this.fnGetSelectList()
    this.fnGetRecipeList()
    this.fnGetCompanyRecipeList()
  },
  methods: {
    changeType: function() {

    },
    fnGetRecipeList: function() {
      this.$http.getRecipeList(this.listQuery).then(res => {
        this.tableKey++
        this.list = res.data.list
        this.total = parseInt(res.data.count)
      })
    },
    fnGetCompanyRecipeList: function() {
      this.$http.getRecipeList(this.companylListQuery).then(res => {
        this.companyTableKey++
        this.companyLists = res.data.list
        console.log(res.data.list)
        this.companyTotal = parseInt(res.data.count)
      })
    },
    fnGetSelectList: function() {
      this.$http.getDeploy().then(res => {
        this.selectList = res.data.recipe_status
      })
    },
    fnToAddMenuDetail: function(id) {
      var params = {
        path: this.tabActiveName == 'school' ? 'addMenu' : 'addCompayMenu'
      }
      if (id) {
        params['query'] = id
      }
      this.$router.push(params)
    },
    fnReleaseMenu: function() {
      this.$confirm('发布菜谱后无法更改, 是否继续?', '确认发布', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.sendMeal({ 'sendMaster': this.tabActiveName == 'school' ? 1 : 0 }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.fnGetRecipeList()
            this.fnGetCompanyRecipeList()
          }
        })
      })
    },
    fnDeleteMenu: function(recipe_id) {
      this.$confirm('是否确认删除菜谱?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delRecipe({ recipe_id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.fnGetRecipeList()
          }
        })
      })
    },
    fnUpdateMenu: function(id) {
      this.$router.push({
        path: this.tabActiveName == 'school' ? 'addMenu' : 'addCompayMenu',
        query: { id }
      })
    },
    chechTimeExpire: function(time) {
      if (time) {
        return moment(time).isSameOrAfter(moment())
      }
      return false
    }
  }
}
</script>
<style lang="scss"  >

  .split-time{
      margin-left:10px;
      margin-right: 10px;
    }
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }

    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
